import { Card, Currency, Group, Stack, Text } from 'ui';

type DonorInfoCardProps = {
  donorName?: string;
  email?: string;
  donationType: 'pledge' | 'flat';
  donationAmount?: number;
};

const DonorInfoCard = ({ donorName, email, donationType, donationAmount }: DonorInfoCardProps) => {
  return (
    <Card bg="cobalt.0" radius={'sm'}>
      <Stack>
        {/* TODO: Update Category styling to be fw 500 once text styles finalized */}
        <Text type="sub" fw={600}>
          Donor Info
        </Text>
        <Stack gap={4}>
          <Group justify="space-between" gap="sm">
            <Group w="45%" gap={'sm'}>
              <Text type="caption" fw={500} w={40}>
                Name:
              </Text>
              <Text type="caption" c="gray.6" truncate>
                {donorName}
              </Text>
            </Group>
            <Group w="45%" gap={'sm'}>
              <Text type="caption" fw={500} w={110}>
                Donation Type:
              </Text>
              <Text type="caption" c="gray.6" tt="capitalize">
                {donationType}
              </Text>
            </Group>
          </Group>
          <Group justify="space-between" gap="sm">
            <Group w="45%" gap={'sm'} wrap="nowrap">
              <Text type="caption" fw={500} w={40}>
                Email:
              </Text>
              <Text type="caption" c="gray.6" truncate>
                {email}
              </Text>
            </Group>
            <Group w="45%" gap={'sm'}>
              <Text type="caption" fw={500} w={110}>
                Donation Amount:
              </Text>
              <Text type="caption" c="gray.6" truncate>
                <Currency value={donationAmount}>{(props) => <>${props.value}</>}</Currency>
              </Text>
            </Group>
          </Group>
        </Stack>
      </Stack>
    </Card>
  );
};

export { DonorInfoCard };
